// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1o2L-","footer":"ModalUpdate_footer__1s2VD"};